import React from 'react';
import { companyInfo } from '../mock';
import { Sparkles } from 'lucide-react';

const Hero = ({ onBooking }) => {
  return (
    <header className="relative pt-64 pb-32 px-6 overflow-hidden">
      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translateX(30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        .animate-fade-in-up {
          animation: fadeInUp 0.8s ease-out forwards;
        }
        .hero-badge {
          opacity: 0;
          animation: fadeInUp 0.8s ease-out forwards;
        }
        .hero-heading {
          opacity: 0;
          animation: fadeInUp 0.8s ease-out forwards;
        }
        .hero-description {
          opacity: 0;
          animation: fadeInUp 0.8s ease-out forwards;
        }
        .hero-buttons {
          opacity: 0;
          animation: fadeInUp 0.8s ease-out forwards;
        }
        .hero-stats {
          opacity: 0;
          animation: fadeInUp 0.8s ease-out forwards;
        }
      `}</style>
      
      {/* Background Glow Effect */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[600px] bg-[#007bff]/10 blur-[150px] rounded-full pointer-events-none"></div>

      <div className="max-w-6xl mx-auto text-center relative z-10">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 glass px-6 py-3 rounded-full mb-8 border-[#007bff]/20 hero-badge" style={{ animationDelay: '0s' }}>
          <Sparkles className="w-4 h-4 text-[#3399ff]" />
          <span className="text-sm font-semibold text-gray-300 uppercase tracking-wider">
            Leads • Growth • Automation
          </span>
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-8 tracking-tighter leading-[1.1] hero-heading" style={{ animationDelay: '0.2s' }}>
          Empowering Businesses with <br />
          <span className="gradient-text">Guaranteed Leads,</span> <br className="hidden md:block" />
          Revenue Growth, and <span className="text-[#007bff]">AI Automation</span>
        </h1>

        <p className="text-lg md:text-2xl text-gray-400 max-w-3xl mx-auto mb-12 leading-relaxed hero-description" style={{ animationDelay: '0.4s' }}>
          AI-powered lead generation, high-converting funnels, and intelligent automation — built for businesses ready to scale predictably.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-6 mb-16 hero-buttons" style={{ animationDelay: '0.6s' }}>
          <button
            onClick={onBooking}
            className="bg-[#007bff] text-white font-black px-12 py-5 rounded-2xl text-xl glow-button"
          >
            Book Free Consultation
          </button>
          <a
            href="#services"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#services')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="glass text-white font-bold px-12 py-5 rounded-2xl text-xl hover:border-[#007bff]/50 transition-all inline-flex items-center justify-center"
          >
            Explore Services
          </a>
        </div>

        {/* Stats */}
        <div
          className="hero-stats flex flex-wrap justify-center gap-8 md:gap-16"
          style={{ animationDelay: '0.8s' }}
        >
          {[
            { num: '7-Fig', label: 'Revenue Scaled' },
            { num: '3×',    label: 'Avg. Lead Volume' },
            { num: 'AI',    label: 'Powered Workflows' },
            { num: '0',     label: 'Leads Lost' },
          ].map((stat, i) => (
            <div key={i} className="text-center relative">
              {i > 0 && (
                <span className="hidden md:block absolute -left-8 top-[10%] bottom-[10%] w-px bg-white/10" />
              )}
              <div className="text-3xl md:text-4xl font-extrabold leading-none text-white">
                {stat.num}
              </div>
              <div className="text-xs text-gray-500 tracking-widest uppercase mt-1">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </header>
  );
};

export default Hero;
